/**
 * Bouton de contact flottant — logique pure (lien, visibilité), partagée par
 * components/FloatingContactButton.jsx et ses tests.
 *
 * Les réglages viennent de la section commune `floating_contact` du pied de
 * page (backend services/theme_engines/shared_widgets.py), valeurs par
 * défaut comprises : toutes les props arrivent en chaînes.
 */

export const FLOATING_CONTACT_TYPE = "floating_contact";

/** Numéro pour wa.me : chiffres seuls, indicatif international obligatoire.
 * « 06 12 34 56 78 » (format français sans indicatif) est converti en
 * « 33612345678 » — l'erreur la plus fréquente à la saisie. */
export function whatsappDigits(phone) {
  let digits = String(phone || "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (/^0\d{9}$/.test(digits)) digits = `33${digits.slice(1)}`;
  return digits.length >= 8 ? digits : "";
}

/** { href, external } pour le canal choisi, ou null si la cible manque. */
export function contactTarget(props = {}) {
  const channel = props.float_channel || "whatsapp";
  const message = String(props.float_message || "").trim();
  if (channel === "whatsapp") {
    const digits = whatsappDigits(props.float_phone);
    if (!digits) return null;
    return { href: `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`, external: true };
  }
  if (channel === "phone") {
    const tel = String(props.float_phone || "").replace(/[^\d+]/g, "");
    return tel.replace(/\D/g, "").length >= 3 ? { href: `tel:${tel}`, external: false } : null;
  }
  if (channel === "email") {
    const email = String(props.float_email || "").trim();
    if (!/^[^\s@<>"]+@[^\s@<>"]+\.[a-z]{2,}$/i.test(email)) return null;
    return { href: `mailto:${email}${message ? `?subject=${encodeURIComponent(message)}` : ""}`, external: false };
  }
  if (channel === "link") {
    const url = String(props.float_link || "").trim();
    if (!url) return null;
    if (url.startsWith("/") || url.startsWith("#")) return { href: url, external: false, internal: url.startsWith("/") };
    if (/^https?:\/\//i.test(url)) return { href: url, external: true };
    return null;
  }
  return null;
}

/** Le bouton s'affiche-t-il sur cette page ? */
export function visibleOnPath(pages, pathname) {
  const p = pathname || "/";
  if (pages === "home") return p === "/";
  if (pages === "except_checkout") return !/^\/(checkout|commande)(\/|$)/.test(p);
  return true;
}

export function toInt(value, fallback, min, max) {
  const n = Number.parseInt(value, 10);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

const HEX = /^#[0-9a-f]{6}$/i;
export function safeColor(value, fallback) {
  return HEX.test(String(value || "")) ? value : fallback;
}
